import { get, post } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./forum-comment.serializer";

export const getForumComments = async (
  token,
  baseUrl,
  projectId,
  forumId,
  params = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/forums/${forumId}/comments`;
  try {
    const res = await get(token, queryPath, params);
    let data = await deserialize(res);
    data = {
      forumComments: data,
      meta: res.meta
    };
    return data;
  } catch (err) {
    throw new Error(err);
  }
};

export const postForumComment = async (
  token,
  baseUrl,
  projectId,
  forumId,
  body = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/forums/${forumId}/comments`;
  try {
    const serializedBody = await serialize(body);
    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
